import React, { useState, useContext } from 'react';
import AuthContext from '../../context/AuthProvider';
// libs
import { useTransition, animated } from 'react-spring';
// assets
import Logo from '../../assets/logo.svg';
import Exit from '../../assets/logout.svg';
// components
import DownloadFiles from '../download-files/DownloadFiles';
import UploadFiles from '../uploadFiles/UploadFiles';

export default function Modal() {
  const { requestLogout, datalogin } = useContext(AuthContext);
  const [type, setType] = useState('upload');
  const [show, setShow] = useState(true);
  const data = [
    { title: 'Subir archivos', value: 'upload' },
    { title: 'Descargar archivos', value: 'download' },
  ];
  /**
   * React spring transitions
   * @param {int} type
   * @returns React component
   */
  const transition = useTransition(type, {
    from: { x: -50, opacity: 0, height: '100%', width: '100%' },
    enter: { x: 0, opacity: 1, height: '100%', width: '100%' },
    // leave: { x: 50, opacity: 0 }
  });

  const handleChangeService = (e) => {
    const value = e.target.value;
    setType(value);
  };

  return (
    <div className="page-container">
      <div className="logout" onClick={requestLogout}>
        <p className="mr-s">Cerrar sesion</p>
        <img src={Exit} alt="" />
      </div>

      <div className="modal">
        <img src={Logo} className="logo" alt="logo" />
        <p className="title" style={{ marginBottom: 10, fontWeight: 'bold' }}>
          {datalogin?.service === 'YUMMER' ? 'Yummers' : 'Comercios'}
        </p>
        {show && <p className="title">que deseas realizar?</p>}

        {show && (
          <div className="type-container">
            {data.map((el, i) => (
              // <div className="selected-container" onClick={selectType}><p>{type}</p></div>
              <label key={el.title} className="selected-container">
                <input
                  type="radio"
                  className="input-radio"
                  checked={type === el.value}
                  name="service"
                  value={el.value}
                  onChange={(e) => handleChangeService(e)}
                />
                <span className="checkmark">{el.title}</span>
              </label>
            ))}
          </div>
        )}

        {transition(
          (style, item) =>
            item === 'download' && (
              <animated.div style={style}>
                <DownloadFiles />
              </animated.div>
            )
        )}
        {transition(
          (style, item) =>
            item === 'upload' && (
              <animated.div style={style}>
                <UploadFiles setShow={setShow} />
              </animated.div>
            )
        )}
      </div>
    </div>
  );
}
